module.exports = __webpack_public_path__ + "assets/images/magenta_sport_8.e126e5a7b423475008ddbfff6ab6aafa.png";